var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.863,
    height: 50.863,
    viewBox: "0 0 50.863 50.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_519",
    "data-name": "Trac\\xE9 519",
    d: "M27.432,2A25.432,25.432,0,1,0,52.863,27.432,25.408,25.408,0,0,0,27.432,2ZM40.148,36.562l-3.586,3.586-9.13-9.13-9.13,9.13-3.586-3.586,9.13-9.13-9.13-9.13L18.3,14.716l9.13,9.13,9.13-9.13L40.148,18.3l-9.13,9.13Z",
    transform: "translate(-2 -2)",
    fill: "#ff3b00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0e9205feb4be8fb1b55ed6c7788ff60e.svg";
export { ForwardRef as ReactComponent };